import React, { useState, useCallback, useEffect } from 'react'
import Sidebar from './Sidebar'
import HelpWidget from '../help/HelpWidget'

const PAGE_TITLES = {
  dashboard: 'Tableau de bord',
  chantiers: 'Chantiers',
  taches: 'Taches',
  messages: 'Messages',
  notifications: 'Notifications',
  documents: 'Documents',
  photos: 'Photos',
  intervenants: 'Intervenants',
  avancement: 'Avancement du chantier',
}

export default function AppLayout({ role, activePage, onNavigate, user, onLogout, profile, children, onRelancerTutoriel }) {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [now, setNow] = useState(new Date())

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000)
    return () => clearInterval(timer)
  }, [])

  const handleNavigate = useCallback((page) => {
    onNavigate(page)
    setSidebarOpen(false)
  }, [onNavigate])

  return (
    <div className="app-layout">
      <button
        className="sidebar-hamburger"
        onClick={() => setSidebarOpen(o => !o)}
        aria-label="Menu"
      >
        {sidebarOpen ? '✕' : '☰'}
      </button>

      <div
        className={'sidebar-overlay' + (sidebarOpen ? ' visible' : '')}
        onClick={() => setSidebarOpen(false)}
      />

      <Sidebar
        role={role}
        activePage={activePage}
        onNavigate={handleNavigate}
        user={user}
        onLogout={onLogout}
        profile={profile}
        isOpen={sidebarOpen}
      />

      <div className="main-content">
        <header className="topbar">
          <h2 className="topbar-title">{PAGE_TITLES[activePage] || activePage}</h2>
          <div className="topbar-actions">
            <span style={{ fontSize: 13, color: 'var(--gray-500)', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', lineHeight: 1.4 }}>
              <span>{now.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}</span>
              <span style={{ fontWeight: 600, color: 'var(--primary)', fontSize: 14 }}>{now.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}</span>
            </span>
          </div>
        </header>
        <main className="page-content">
          {children}
        </main>
      </div>
      <HelpWidget role={role} onRelancerTutoriel={onRelancerTutoriel} />
    </div>
  )
}
